<template>
  <div>
        <div v-if="loadingHome" class="data-loading" style="text-align: center;position: fixed;width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;z-index: 100;background: #FFF;">
            <van-loading size="35" color="#de5d0a" />
        </div>
  </div>
</template>

<script>
import {Loading} from "vant";
export default {
    components: {
        [Loading.name]: Loading,
    },
    data() {
        return {
            loadingHome: true,
            profile: {
                id: "",
                firstName: "Passenger",
                middleName: "",
                lastName: "",
                fullName: "",
                sex: "",
                dobShort: "",
                nationality: "",
                phone: "", // +85568203911
                email: "",
                lang: "en", // en, kh,
            },
        }
    },
    methods: {},
    created() {
        // Set timeout
        setTimeout(() => {
            this.$router.push("/Home");
        }, 5000);
    }, 
    mounted() {
        // get profile from native app
        this.$bridge.callHandler("getProfile").then((data) => {
            this.profile = data;
            // Set User Phone Default
            localStorage.setItem('userphone', this.profile.phone);
            localStorage.setItem('username', this.profile.firstName);
            localStorage.setItem('lastname', this.profile.lastName);
            localStorage.setItem('fullName', this.profile.fullName);
            localStorage.setItem('sex', this.profile.sex);
            localStorage.setItem('nationality', this.profile.nationality);
            this.$i18n.locale = this.profile.lang;
            this.$router.push("/Home");
        });
    }
}
</script>

<style>

</style>